import React from 'react';
import { Box, Link, Text } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';

import { IMassageWellbeingInfoBarType } from '@epi-models/containers/ManageBenefitGroups';
import { InfoBar } from '@epi-shared/components';

export const MassageWellbeingInfoBar = ({
  benefitGroup
}: IMassageWellbeingInfoBarType) => {
  const { t } = useTranslation();

  return (
    <Box mb={3} id="benefit-group-details-info-bar">
      <InfoBar
        node={
          <>
            <Box mb={1}>
              <Text id="benefit-group-details-daily-limit-statement-text">
                {t(`components.manage_benefit_${benefitGroup}.mst_description`)}
              </Text>
            </Box>
            <Box mb={1}>
              <Text id="benefit-group-details-daily-limit-statement-text">
                <Trans
                  i18nKey={`components.manage_benefit_${benefitGroup}.mst_instructions`}
                  components={{
                    a: (
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        href={t(
                          `components.manage_benefit_${benefitGroup}.mst_instructions_link`
                        )}
                      />
                    )
                  }}
                />
              </Text>
            </Box>
            <Box>
              <Text id="benefit-group-details-daily-limit-statement-text">
                <Trans
                  i18nKey={`components.manage_benefit_${benefitGroup}.mst_cta`}
                  components={{
                    a: (
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        href={t(
                          `components.manage_benefit_${benefitGroup}.mst_cta_link`
                        )}
                      />
                    )
                  }}
                />
              </Text>
            </Box>
          </>
        }
      />
    </Box>
  );
};
